import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


const CheckYourEmail = () => {
  const navigate = useNavigate();
  const {loginWithRedirect} = useAuth(); // Check if the user is authenticated

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Check Your Email
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          A verification link has been sent to your email address. 
          Please check your inbox and follow the link to verify your account.
        </Typography>
        <Typography variant="body2" sx={{ mt: 2, color: 'gray' }}>
          If you don't see the email, check your spam folder or wait a few minutes.
        </Typography>
        <Box mt={4} display="flex" flexDirection="column" alignItems="center">
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => loginWithRedirect()}
            sx={{ mb: 2 }}
          >
            Return to Login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default CheckYourEmail;